<template>
  <div>
    <div class="relative bg-white rounded-2xl shadow-md p-6 mx-auto">
      <span :class="['px-4 py-1 rounded-lg font-bold text-sm absolute top-4 right-4', statusStyle(product.status)]">
        {{ t(`unfixeable_claim_products.status.${product.status}`) }}
      </span>

      <h2 class="text-xl font-bold text-center mt-6 mb-8">{{ product.product?.title }}</h2>

      <div class="space-y-2">
        <FieldRow :label="t('declared_at')" :value="formattedDeclaredAt" />
        <FieldRow :label="t('store')" :value="product.store" />
        <FieldRow :label="t('price')" :value="formattedPrice" />
        <FieldRow :label="t('reason')" :value="product.reason" />
        <FieldRow :label="t('tracking_number')" :value="product.trackingNumber" />
        <FieldRow :label="t('valuation_amount')" :value="product.valuationAmount" />
        <FieldRow v-if="product.irreparabilityCertificateUrl" :label="t('certificate')">
          <a
            class="text-blue-400 underline"
            :href="product.irreparabilityCertificateUrl"
            target="_blank"
            data-test="irreparability-certificate-link"
          >
            {{ t("link") }}
          </a>
        </FieldRow>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { useI18n } from "vue-i18n";
import { FieldRow } from "@estaly/ui";
import { formatAnalyticsDate } from "@/utils/date_formatter";

export default {
  components: { FieldRow },

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    ...mapGetters("unfixeableClaimProducts", ["statusStyle"]),

    formattedPrice() {
      return `${this.product.product?.price} ${this.product.product?.currencyCode}`;
    },

    formattedDeclaredAt() {
      return formatAnalyticsDate(this.product.declaredAt, "dd/MM/yyyy HH:mm");
    },
  },
};
</script>

<i18n src="./ClaimIrreparabilityInformation.i18n.json"></i18n>
